'use strict'

module.exports = {
    // Known qualifiers:
    // https://github.com/package-url/purl-spec/blob/master/PURL-SPECIFICATION.rst#known-qualifiers-keyvalue-pairs
    PurlQualifierNames: {
        __proto__: null,
        RepositoryUrl: 'repository_url',
        DownloadUrl: 'download_url',
        VcsUrl: 'vcs_url',
        FileName: 'file_name',
        Checksum: 'checksum'
    }
}
